module.exports = __webpack_public_path__ + "img/tips1_botlist1img19120501.3b0ff746.jpg";